import React, { useState } from "react";
import api from "@/lib/api";
import { ChatServico } from "@/components/ChatServico";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { UserCog, MessageCircle } from "lucide-react";

const Badge = ({ n }) => (n > 0 ? (
  <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-[#E60000] text-white text-[10px] font-bold flex items-center justify-center">
    {n > 9 ? "9+" : n}
  </span>
) : null);

export const ChatOsBotoes = ({ servico, meuTipo, naoLidas, onLido }) => {
  const [aberto, setAberto] = useState(null);
  const fechar = () => { setAberto(null); onLido && onLido(); };
  const tipoNoCanal = aberto === "externo" && (meuTipo === "empresa" || meuTipo === "montadora")
    ? "central" : meuTipo;
  return (
    <>
      <div className="flex gap-1.5">
        <button onClick={() => setAberto("interno")}
          title="Falar com Montador — chat interno (o cliente nunca vê)"
          className="relative w-8 h-8 border border-[#93C5FD] bg-[#EFF6FF] text-[#142766] flex items-center justify-center hover:bg-[#DBEAFE] transition-colors"
          data-testid={`chat-interno-btn-${servico.id}`}>
          <UserCog size={15} /><Badge n={naoLidas?.interno} />
        </button>
        <button onClick={() => setAberto("externo")}
          title="Falar com Cliente — chat externo (o cliente vê)"
          className="relative w-8 h-8 border border-[#FDBA74] bg-[#FFF7ED] text-[#B45309] flex items-center justify-center hover:bg-[#FFEDD5] transition-colors"
          data-testid={`chat-externo-btn-${servico.id}`}>
          <MessageCircle size={15} /><Badge n={naoLidas?.externo} />
        </button>
      </div>
      <Sheet open={!!aberto} onOpenChange={(o) => !o && fechar()}>
        <SheetContent side="right" className="w-full sm:max-w-xl overflow-y-auto" data-testid="chat-os-dialog">
          <SheetHeader>
            <SheetTitle className="text-base">
              {aberto === "interno"
                ? `Falar com o Montador — ${servico.cliente_nome || servico.pim_code}`
                : `Falar com o Cliente — ${servico.cliente_nome || servico.pim_code}`}
            </SheetTitle>
          </SheetHeader>
          <div className="mt-1 space-y-2">
          {aberto === "interno" && (
            <div className="text-[11px] text-muted-foreground -mt-2" data-testid="chat-interno-aviso">
              🔒 Canal interno e privado: o cliente <strong>nunca</strong> vê estas mensagens.
            </div>
          )}
          {aberto === "externo" && (
            <div className="text-[11px] text-muted-foreground -mt-2" data-testid="chat-externo-aviso">
              👁 O cliente vê este canal. Sua mensagem aparece como <strong>Central</strong> e o cliente é avisado por WhatsApp.
            </div>
          )}
          {aberto && (
            <ChatServico meuTipo={tipoNoCanal}
              titulo={aberto === "interno" ? "Canal interno (montador × central)" : "Canal externo (com o cliente)"}
              listar={async () => (await api.get(`/servicos/${servico.id}/chat`, { params: { canal: aberto } })).data}
              enviar={async (t) => api.post(`/servicos/${servico.id}/chat`, { texto: t, canal: aberto })} />
          )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
